import React, { useState } from "react";
import { supabase } from "../../supabaseClient";

const labelStyle = {
  fontSize: "14px",
  fontWeight: "bold",
  color: "#1E5631",
  display: "block",
  marginBottom: "4px"
};

function AdminDataRumah({ houses, setHouses, styles }) {
  const [mode, setMode] = useState(null); // null | "tambah" | "edit"
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [editNama, setEditNama] = useState("");
  const [editHp, setEditHp] = useState("");
  const [editPin, setEditPin] = useState("");
  const [editAktif, setEditAktif] = useState(true);
  const [editNomorRumah, setEditNomorRumah] = useState("");
  const [saving, setSaving] = useState(false);

  // Form tambah data baru
  const [newNomorRumah, setNewNomorRumah] = useState("");
  const [newNama, setNewNama] = useState("");
  const [newHp, setNewHp] = useState("");
  const [newPin, setNewPin] = useState("");
  const [newAktif, setNewAktif] = useState(true);
  const [adding, setAdding] = useState(false);

  async function reloadWarga() {
    const { data } = await supabase
      .from("warga")
      .select("*")
      .order("nomor_rumah");
    setHouses(data || []);
  }

  async function simpanData() {
    if (!selected) return;
    setSaving(true);

    // Jika nomor rumah diubah, cek apakah nomor baru sudah dipakai warga lain
    if (editNomorRumah.trim() !== String(selected.nomor_rumah || "").trim()) {
      const exists = houses.find(
        (h) =>
          String(h.nomor_rumah || "").trim().toUpperCase() ===
          editNomorRumah.trim().toUpperCase()
      );
      if (exists) {
        alert(
          "Nomor rumah " +
            editNomorRumah +
            " sudah digunakan oleh warga lain (" +
            exists.nama +
            ")!"
        );
        setSaving(false);
        return;
      }
    }

    const { error } = await supabase
      .from("warga")
      .update({
        nomor_rumah: editNomorRumah.trim(),
        nama: editNama,
        no_hp: editHp,
        pin: editPin,
        aktif: editAktif
      })
      .eq("nomor_rumah", selected.nomor_rumah);

    if (error) {
      alert("Gagal menyimpan: " + error.message);
      setSaving(false);
      return;
    }

    await reloadWarga();
    setSelected(null);
    setSaving(false);
    alert("Data warga berhasil diperbarui!");
  }

  async function tambahDataBaru(e) {
    e.preventDefault();
    if (!newNomorRumah.trim() || !newNama.trim()) {
      alert("Nomor rumah dan nama warga wajib diisi!");
      return;
    }

    // Cek apakah nomor rumah sudah ada
    const existing = houses.find(
      (h) =>
        String(h.nomor_rumah || "").trim().toUpperCase() ===
        newNomorRumah.trim().toUpperCase()
    );
    if (existing) {
      alert(
        "Nomor rumah " +
          newNomorRumah +
          " sudah terdaftar dengan nama " +
          existing.nama +
          "!"
      );
      return;
    }

    setAdding(true);
    const { error } = await supabase.from("warga").insert([
      {
        nomor_rumah: newNomorRumah.trim(),
        nama: newNama.trim(),
        no_hp: newHp.trim(),
        pin: newPin.trim() || "123456",
        aktif: newAktif
      }
    ]);

    if (error) {
      alert("Gagal menambah data: " + error.message);
      setAdding(false);
      return;
    }

    await reloadWarga();
    setNewNomorRumah("");
    setNewNama("");
    setNewHp("");
    setNewPin("");
    setNewAktif(true);
    setAdding(false);
    alert(
      "Data warga baru berhasil ditambahkan dan langsung muncul di website warga!"
    );
  }

  const filtered = houses.filter((h) => {
    const q = search.toLowerCase().trim();
    if (!q) return true;
    return (
      String(h.nomor_rumah || "").toLowerCase().includes(q) ||
      String(h.nama || "").toLowerCase().includes(q)
    );
  });

  return (
    <div>
      <div
        style={{
          fontSize: "19px",
          fontWeight: "bold",
          color: "#1E5631",
          marginBottom: "14px"
        }}
      >
        Data Manajemen Rumah Warga
      </div>

      {/* ===== PILIHAN MENU ===== */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          marginBottom: "18px"
        }}
      >
        <button
          onClick={() => setMode("tambah")}
          style={{
            padding: "16px",
            borderRadius: "12px",
            border:
              mode === "tambah" ? "2px solid #1E5631" : "1px solid #EAEBE6",
            background: mode === "tambah" ? "#1E5631" : "#fff",
            color: mode === "tambah" ? "#fff" : "#1E5631",
            fontWeight: "bold",
            fontSize: "15px",
            cursor: "pointer",
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            boxShadow: "0 2px 8px rgba(0,0,0,.08)"
          }}
        >
          <span style={{ fontSize: "22px" }}>➕</span>
          <div>
            <div>Tambah Data Baru</div>
            <div
              style={{
                fontSize: "12px",
                fontWeight: "normal",
                color: mode === "tambah" ? "#cfe6d8" : "#888"
              }}
            >
              Tambahkan data warga baru
            </div>
          </div>
        </button>

        <button
          onClick={() => setMode("edit")}
          style={{
            padding: "16px",
            borderRadius: "12px",
            border: mode === "edit" ? "2px solid #1E5631" : "1px solid #EAEBE6",
            background: mode === "edit" ? "#1E5631" : "#fff",
            color: mode === "edit" ? "#fff" : "#1E5631",
            fontWeight: "bold",
            fontSize: "15px",
            cursor: "pointer",
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            boxShadow: "0 2px 8px rgba(0,0,0,.08)"
          }}
        >
          <span style={{ fontSize: "22px" }}>✏️</span>
          <div>
            <div>Edit Data Warga</div>
            <div
              style={{
                fontSize: "12px",
                fontWeight: "normal",
                color: mode === "edit" ? "#cfe6d8" : "#888"
              }}
            >
              Ubah data warga yang sudah ada
            </div>
          </div>
        </button>
      </div>

      {/* ===== KONTEN: TAMBAH DATA BARU ===== */}
      {mode === "tambah" && (
        <div
          style={{
            background: "#fff",
            padding: "18px",
            borderRadius: "14px"
          }}
        >
          <div
            style={{
              fontSize: "14px",
              color: "#666",
              marginBottom: "14px"
            }}
          >
            Isi data warga baru di bawah ini. Data akan langsung muncul di
            website warga.
          </div>
          <form onSubmit={tambahDataBaru}>
            <label style={labelStyle}>Nomor Rumah *</label>
            <input
              style={{ ...styles.input, marginBottom: "14px" }}
              placeholder="Contoh: C1/15"
              value={newNomorRumah}
              onChange={(e) => setNewNomorRumah(e.target.value)}
              required
            />

            <label style={labelStyle}>Nama Warga *</label>
            <input
              style={{ ...styles.input, marginBottom: "14px" }}
              placeholder="Nama lengkap warga"
              value={newNama}
              onChange={(e) => setNewNama(e.target.value)}
              required
            />

            <label style={labelStyle}>Nomor HP</label>
            <input
              style={{ ...styles.input, marginBottom: "14px" }}
              placeholder="08xxxxxxxxxx"
              value={newHp}
              onChange={(e) => setNewHp(e.target.value)}
            />

            <label style={labelStyle}>PIN Warga</label>
            <input
              style={{ ...styles.input, marginBottom: "14px" }}
              placeholder="Default: 123456"
              value={newPin}
              onChange={(e) => setNewPin(e.target.value)}
            />

            <label
              style={{
                ...labelStyle,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "14px"
              }}
            >
              <input
                type="checkbox"
                checked={newAktif}
                onChange={(e) => setNewAktif(e.target.checked)}
              />
              Akun Aktif
            </label>

            <button
              type="submit"
              style={styles.btnPrimary}
              disabled={adding}
            >
              {adding ? "Menambahkan..." : "➕ Tambah Data Warga"}
            </button>
          </form>
        </div>
      )}

      {/* ===== KONTEN: EDIT DATA WARGA ===== */}
      {mode === "edit" && (
        <div>
          <input
            style={styles.input}
            placeholder="🔍 Cari nomor rumah / nama warga..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "6px"
            }}
          >
            {filtered.length === 0 && (
              <div
                style={{
                  textAlign: "center",
                  color: "#888",
                  padding: "20px",
                  fontSize: "14px"
                }}
              >
                Belum ada data warga terdaftar di database.
              </div>
            )}
            {filtered.map((h, i) => (
              <div
                key={i}
                onClick={() => {
                  setSelected(h);
                  setEditNama(h.nama || "");
                  setEditHp(h.no_hp || "");
                  setEditPin(h.pin || "");
                  setEditAktif(h.aktif !== false);
                  setEditNomorRumah(h.nomor_rumah || "");
                }}
                style={{
                  background: "#fff",
                  padding: "12px 14px",
                  borderRadius: "8px",
                  display: "flex",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  borderLeft: h.aktif === false ? "4px solid #B23B3B" : "none"
                }}
              >
                <strong>{h.nomor_rumah}</strong>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontWeight: "bold" }}>{h.nama}</div>
                  <div style={{ fontSize: "12px", color: "#888" }}>
                    {h.no_hp || "-"}
                  </div>
                  {h.aktif === false && (
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#B23B3B",
                        fontWeight: "bold"
                      }}
                    >
                      Nonaktif
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {selected && (
            <div
              onClick={() => setSelected(null)}
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.45)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  background: "#fff",
                  width: "92%",
                  maxWidth: "420px",
                  borderRadius: "14px",
                  padding: "20px",
                  maxHeight: "85vh",
                  overflowY: "auto"
                }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#1E5631",
                    marginBottom: "4px"
                  }}
                >
                  ✏️ Edit Data Warga
                </div>
                <div
                  style={{
                    fontSize: "13px",
                    color: "#888",
                    marginBottom: "16px"
                  }}
                >
                  Ubah data yang salah, lalu klik Simpan.
                </div>

                <label style={labelStyle}>Nomor Rumah</label>
                <input
                  style={{ ...styles.input, marginBottom: "14px" }}
                  placeholder="Nomor Rumah"
                  value={editNomorRumah}
                  onChange={(e) => setEditNomorRumah(e.target.value)}
                />

                <label style={labelStyle}>Nama Warga</label>
                <input
                  style={{ ...styles.input, marginBottom: "14px" }}
                  placeholder="Nama Warga"
                  value={editNama}
                  onChange={(e) => setEditNama(e.target.value)}
                />

                <label style={labelStyle}>Nomor HP</label>
                <input
                  style={{ ...styles.input, marginBottom: "14px" }}
                  placeholder="Nomor HP"
                  value={editHp}
                  onChange={(e) => setEditHp(e.target.value)}
                />

                <label style={labelStyle}>PIN</label>
                <input
                  style={{ ...styles.input, marginBottom: "14px" }}
                  placeholder="PIN"
                  value={editPin}
                  onChange={(e) => setEditPin(e.target.value)}
                />

                <label
                  style={{
                    ...labelStyle,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "14px"
                  }}
                >
                  <input
                    type="checkbox"
                    checked={editAktif}
                    onChange={(e) => setEditAktif(e.target.checked)}
                  />
                  Akun Aktif
                </label>

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    marginTop: "10px"
                  }}
                >
                  <button
                    style={{
                      ...styles.btnPrimary,
                      flex: 1
                    }}
                    disabled={saving}
                    onClick={simpanData}
                  >
                    {saving ? "Menyimpan..." : "💾 Simpan Perubahan"}
                  </button>

                  <button
                    style={{
                      ...styles.btnGhost,
                      flex: 1
                    }}
                    onClick={() => setSelected(null)}
                  >
                    Tutup
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default AdminDataRumah;